// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const AUTH_KEY_PREFIX = 'CognitoIdentityServiceProvider';

export { AUTH_KEY_PREFIX };
//# sourceMappingURL=constants.mjs.map
